// extracted by mini-css-extract-plugin
export default {"cls1":"vCyKb8x0a25IkSg0xamq","cls2":"ICNvrw88GbXgaGgWMZre vCyKb8x0a25IkSg0xamq"};